export function reload() {
  // // ページがリロードされる前にスクロール位置をリセット
  // window.addEventListener('beforeunload', () => {
  //   window.scrollTo(0, 0);
  // });
  // // リサイズ時のリロード
  // let resizeTimer;
  // window.addEventListener("resize", () => {
  //   clearTimeout(resizeTimer);
  //   resizeTimer = setTimeout(() => {
  //     location.reload();
  //   }, 300);
  // });
}
